import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { WLItem, WishlistActionPayload } from '../../../domain/models/wishlist.models';
import { AddItemsWishlistAction, DeleteItemWishlistAction, LoadWishlistAction } from '../../state/wishlist-commands.actions';

@Injectable()
export class WishlistCommandsFacade {
    private readonly store: Store = inject(Store);

    public deleteItemWishlistAction(item: WLItem): void {
        this.store.dispatch(DeleteItemWishlistAction({ item }));
    }

    public loadWishlistAction(): void {
        this.store.dispatch(LoadWishlistAction());
    }

    public addItemsWishlistAction(items: WishlistActionPayload): void {
        this.store.dispatch(AddItemsWishlistAction(items));
    }
}
